/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterJsonBlob extends models.ParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ParameterJsonBlob");
    }

    getFixupPrototypeFunction() { return ParameterJsonBlob.fixupPrototype; }

    static newInstance(model: Partial<ParameterJsonBlob>): ParameterJsonBlob {
        let obj = Object.assign(new ParameterJsonBlob(), model);
        ParameterJsonBlob.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterJsonBlob>): ParameterJsonBlob {
        if (!model) return null;
        return ParameterJsonBlob.newInstance(<ParameterJsonBlob> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterJsonBlob) {
        if (!obj) return;

        models.ParameterJsonBlob.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterJsonBlob): boolean {
        if (models.ParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterJsonBlob.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
